import BaseCefCommercialService from "./base.service";
import { CefVersion } from "./constants";
import { activityLogArea } from "../user-tracking-helper";

type ClearErrorResponse = {
    status: string,
    id: string,
    detail: string,
    distributionPlatform: string
}

export type GetClearErrorStatusResponse = {
    getStatusResponse: ClearErrorResponse[]
}

export type ClearErrorRequestResponse = {
    clearErrorResponse: ClearErrorResponse[]
}


class ClearErrorService extends BaseCefCommercialService {
    constructor() {
        super(activityLogArea.clearError);
        this.setBaseUrl(`CEFCommClearErrorAPI/${CefVersion}`);
    }

    clear(smartCardNumber: string, errorCode: string) {
        const request: any = {
            errorCode: errorCode,
            smartCardNumber: smartCardNumber,
        };

        this.userTracking.execute(request);

        return this.createPromiseRequest("/clearError").post<ClearErrorRequestResponse>(request);
    }

    status(id: string, distributionPlatform: string) {
        return this.createPromiseRequest(`/getStatus?id=${id}&distributionPlatform=${distributionPlatform}`).get<GetClearErrorStatusResponse>();
    }
}

export default ClearErrorService;
